<template>
    <div class="loading-inline-container" :class="{show: visible}">
        <div class="loading-content" style="">
            <div class="spinner">
                <div class="spinner__item1"></div>
                <div class="spinner__item2"></div>
                <div class="spinner__item3"></div>
                <div class="spinner__item4"></div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'loadinginline',

        data () {
            return {
                visible: true,
            }
        },

        methods: {
            show: function () {
                //alert('LOADING');
                this.visible = true;

            },

            hide: function () {


                this.visible = false;

            },


        },

        mounted: function () {

        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .loading-inline-container {
        background-color: rgba($main-white,0.50);
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        pointer-events: none;
        //transform: scale(0);
        z-index: $z-messages - 25;
        transition-property: opacity;

        .loading-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .spinner {
                margin: 0 auto;
                width: 100px;
                text-align: center;
            }

            .spinner > div {
                width: 16px;
                height: 16px;
                background-color: $main-grey;
                border-radius: 100%;
                display: inline-block;
                animation: sk-bouncedelay 1.7s infinite ease-in-out both;
                margin-right: 5px;
            }

            .spinner .spinner__item1 {
                animation-delay: -0.60s;
            }

            .spinner .spinner__item2 {
                animation-delay: -0.40s;
            }

            .spinner .spinner__item3 {
                animation-delay: -0.20s;
            }

            @keyframes sk-bouncedelay {
                0%, 80%, 100% {
                    transform: scale(0);
                    opacity: 0;
                } 40% {
                      transform: scale(1.0);
                      opacity: 1;
                  }
            }
        }

        &.show {
            opacity: 1;
            pointer-events: auto;
            //transform: scale(1);
        }
    }
</style>
